/* Побег из встроенного браузера (in-app webview: реклама открывает сайт внутри приложения паблишера, где
 * PWA не ставится и пуши не работают). Android — intent:// уводит в системный https-браузер, iOS 17+ —
 * x-safari-https:// открывает Safari. Обе схемы срабатывают ТОЛЬКО по тапу человека; вызывающий обязан дать
 * запасной путь (кнопка «продолжить здесь»), если webview проглотил схему — страница осталась видимой.
 * 🔴 Судьбу побега решает человек, а не таймер: системный диалог «открыть в другом приложении» держит
 * страницу видимой, и таймер уводит человека из-под открытого диалога (StaySubscribed: 4 из 4 прогонов).
 * Функции чистые (без window/navigator) — покрыты тестами webview.test.ts. Перенесено из staysubscribed. */
// Явные in-app браузеры + маркер Android system WebView "; wv)".
const IN_APP_UA = /FBAN|FBAV|FB_IAB|Instagram|Line\/|TikTok|musical_ly|Bytedance|Snapchat|Twitter|WhatsApp|Pinterest|GSA\/|; wv\)/i;
export function isInAppWebView(ua, standalone, hasServiceWorker) {
    if (standalone)
        return false; // наша PWA: её UA тоже без "Safari/"
    if (IN_APP_UA.test(ua))
        return true;
    if (!/iphone|ipad|ipod/i.test(ua))
        return false;
    // Голый WKWebView выдаёт себя отсутствием токена "Safari/" — у Safari, CriOS, FxiOS, EdgiOS он есть.
    if (!/safari\//i.test(ua))
        return true;
    /* Явный маркер стороннего браузера — это НЕ webview, что бы ни говорил Service Worker: в Chrome iOS инкогнито
     * SW недоступен, и эвристика ниже предлагала человеку выйти из приватного режима, который он выбрал сам. */
    if (/CriOS|FxiOS|EdgiOS|OPiOS|OPT\//i.test(ua))
        return false;
    /* SFSafariViewController (Telegram и др.): UA как у Safari, но Service Worker недоступен. Приватный Safari —
     * ложное срабатывание, терпимое: x-safari-https открывает тот же Safari без системного запроса. */
    return !hasServiceWorker;
}
/** intent:// (Android) или x-safari-https:// (iOS) для https-цели, иначе null. */
export function escapeUrl(absUrl, ua) {
    const bare = absUrl.replace(/^https:\/\//, "");
    if (bare === absUrl)
        return null;
    if (/android/i.test(ua))
        return `intent://${bare}#Intent;scheme=https;action=android.intent.action.VIEW;end`;
    if (/iphone|ipad|ipod/i.test(ua))
        return `x-safari-https://${bare}`;
    return null;
}
/** Среда страницы одним взглядом (для диагностики): standalone | in-app webview | browser. */
export function browsingMode(ua, standalone, hasServiceWorker) {
    return standalone ? "standalone" : isInAppWebView(ua, standalone, hasServiceWorker) ? "webview" : "browser";
}
/** Маркер нативной оболочки G1 iOS (репо g1-ios): WKWebView приложения добавляет к UA суффикс
 * `G1App/<version> (iOS)` через `applicationNameForUserAgent`. Внутри оболочки веб-приложение прячет
 * кросс-приложенческий лаунчер и web-push (их даёт нативный слой), а навигация между приложениями идёт
 * через `window.webkit.messageHandlers.G1App`. Единственное место, где этот факт объявлен. */
export const G1_APP_UA_RX = /\bG1App\/(\d+(?:\.\d+)*)/;
export function isG1App(ua) {
    return G1_APP_UA_RX.test(ua);
}
/** Версия оболочки из UA (`"1.2.0"`) или null вне оболочки. */
export function g1AppVersion(ua) {
    return G1_APP_UA_RX.exec(ua)?.[1] ?? null;
}
//# sourceMappingURL=webview.js.map